import { InitialStateType } from "../types";

export const InitialState: InitialStateType = {
  chanelInfo: {
    name: "",
    description: "",
  },

  adminAccount: {
    name: "",
    token: "",
    grantState: "Unknown",
    error: "",
  },

  userAccount: {
    name: "",
    token: "",
    grantState: "Unknown",
    error: "",
    use: true,
  },

  teamsConfig: {
    team: "",
    channel: "",
    mentionTeam: false,
    mentionChannel: false,
  },

  grantedAccounts: {
    admin: "",
    user: "",
  },
};

const wizardStateReducer = (state: any, action: any) => {
  const form = action.payload.form;
  switch (action.type) {
    case "update":
      return {
        ...state,
        [form]: {
          ...state[form],
          ...action.payload.data,
        },
      };

    default:
      return state;
  }
};

export default wizardStateReducer;
